import {
  RECEIVE_VISUAL_SEARCH_FAILURE,
  RECEIVE_VISUAL_SEARCH_INPUT_IMAGE,
  RECEIVE_VISUAL_SEARCH_SUCCESS,
  REQUEST_VISUAL_SEARCH,
  RESET_VISUAL_SEARCH_INPUT_IMAGE,
  RESET_VISUAL_SEARCH_RESULTS
} from 'constants/reduxActions';
import { VisualSearchData } from 'components/VisualSearch/VisualSearchResults/visualSearchResults.types';
import { mockVisualSearchResultsData } from 'testHelpers/mock_data/visual_search_results';

export function requestVisualSearch() {
  return {
    type: REQUEST_VISUAL_SEARCH
  } as const;
}

export function receiveVisualSearchSuccess(visualSearchData: VisualSearchData) {
  return {
    type: RECEIVE_VISUAL_SEARCH_SUCCESS,
    visualSearchData
  } as const;
}

export function receiveVisualSearchFailure() {
  return {
    type: RECEIVE_VISUAL_SEARCH_FAILURE
  } as const;
}

export function resetVisualSearchResults() {
  return {
    type: RESET_VISUAL_SEARCH_RESULTS
  } as const;
}

export function receiveVisualSearchInputImage(inputImage: File) {
  return {
    type: RECEIVE_VISUAL_SEARCH_INPUT_IMAGE,
    inputImage
  } as const;
}

export function resetVisualSearchInputImage() {
  return {
    type: RESET_VISUAL_SEARCH_INPUT_IMAGE
  } as const;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function fetchVisualSearch(image: string) {
  // todo - image type will be changed to 'file' & call api from here
  // adding fake timeout for testing purpose - will be removed after adding api
  return function (dispatch: any) {
    dispatch(resetVisualSearchResults());
    dispatch(requestVisualSearch());
    setTimeout(() => {
      dispatch(receiveVisualSearchSuccess(mockVisualSearchResultsData));
    }, 2000);
  };
}

export type VisualSearchAction =
  | ReturnType<typeof requestVisualSearch>
  | ReturnType<typeof receiveVisualSearchSuccess>
  | ReturnType<typeof receiveVisualSearchFailure>
  | ReturnType<typeof resetVisualSearchResults>
  | ReturnType<typeof receiveVisualSearchInputImage>
  | ReturnType<typeof resetVisualSearchInputImage>;
